module.exports = __webpack_public_path__ + "media/images/action_add_item-5b075c79dcec4c4a08bfea8d4d4c6139.png";